import { debounce } from './utilities';

class MatchHeight {

  private nodeList:NodeList;

  constructor() {
    this.nodeList = null;
  }

  init(selector:string) {
    this.nodeList = document.querySelectorAll(selector);
    this.update();
    window.addEventListener('resize', this.resize.bind(this));
  }

  update() {
    let height = 0;

    this.nodeList.forEach((node:HTMLElement) => { 
      node.style.height = 'auto';
      if (node.offsetHeight > height) height = node.offsetHeight;
    });

    this.nodeList.forEach((node:HTMLElement) => node.style.height = `${ height }px`);
  }

  resize = debounce(() => {
    this.update();
  }, 250);
}

export default new MatchHeight();